export default __webpack_public_path__ + "static/media/jalantikus-logo-white.5ad07855.svg";